import script from "./NoSailingsAvailable.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoSailingsAvailable.vue?vue&type=script&setup=true&lang=ts"

import "./NoSailingsAvailable.vue?vue&type=style&index=0&id=d18de5ba&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d18de5ba"]])

export default __exports__